module.exports = __webpack_public_path__ + "static/media/illustration-sunny-walk.3ac1dcad.svg";